
import getUser from "./functionControllers/getUser";
import getLocations from "./functionControllers/getLocations";
import getProviderOrders from "./functionControllers/getProviderOrders";
import getProviderList from "./functionControllers/getProviderList";
import logout from "./functionControllers/logout";
import getOrders from "./functionControllers/getOrders";
import updateLoadBuild from "./functionControllers/updateLoadBuild";
import loadBuild from "./functionControllers/loadBuild";
import updateFrwdNtfFlag from "./functionControllers/updateFrwdNtfFlag";


const fomApi = {
  getUser,
  getLocations,
  updateFrwdNtfFlag,
  getOrders,
  logout,
  getProviderList,
  getProviderOrders,
  loadBuild,
  updateLoadBuild
};

export default fomApi;
